import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Careers',
    path: '/careers'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 shadow-sm py-4'}`} data-id="element-91">
      <div className="container mx-auto px-4" data-id="element-92">
        <div className="flex items-center justify-between" data-id="element-93">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 transition-transform duration-300 hover:opacity-90" data-id="element-94">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibuVzkycDnA7HHUx1J6KA1/magnavera-logo.jpg" alt="Magnavera Group" className="h-12" data-id="element-95" />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-96">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-poppins font-medium text-sm tracking-wide transition-colors duration-200 ${location.pathname === link.path ? 'text-primary border-b-2 border-primary pb-1' : 'text-text-primary hover:text-primary'}`} data-id="element-97">
                {link.name}
              </Link>)}
            <a href="tel:+6589701506" className="flex items-center text-primary font-poppins font-medium ml-4 hover:text-primary/80 transition-colors duration-200" data-id="element-98">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-99" />
              +65 8970 1506
            </a>
            <Link to="/contact" className="ml-2 bg-primary text-secondary px-6 py-2.5 rounded-lg font-poppins font-medium text-sm uppercase transition-all duration-200 hover:bg-primary/90 hover:shadow-gold-glow" data-id="element-100">
              Get in Touch
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-text-primary p-2" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-101">
            {isMenuOpen ? <XIcon size={24} data-id="element-102" /> : <MenuIcon size={24} data-id="element-103" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden py-6 border-t border-gray-200 mt-4 animate-fadeIn" data-id="element-104">
            <ul className="space-y-5" data-id="element-105">
              {navLinks.map(link => <li key={link.path} data-id="element-106">
                  <Link to={link.path} className={`block font-poppins font-medium text-sm ${location.pathname === link.path ? 'text-primary' : 'text-text-primary'}`} onClick={() => setIsMenuOpen(false)} data-id="element-107">
                    {link.name}
                  </Link>
                </li>)}
              <li data-id="element-108">
                <a href="tel:+6589701506" className="flex items-center text-primary font-poppins font-medium" data-id="element-109">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-110" />
                  +65 8970 1506
                </a>
              </li>
              <li className="pt-2" data-id="element-111">
                <Link to="/contact" className="inline-block bg-primary text-secondary px-6 py-2.5 rounded-lg font-poppins font-medium text-sm uppercase" onClick={() => setIsMenuOpen(false)} data-id="element-112">
                  Get in Touch
                </Link>
              </li>
            </ul>
          </nav>}
      </div>
    </header>;
};
export default Header;